import React from 'react';
interface CTAButtonProps {
  text: string;
  className?: string;
}
export function CTAButton({
  text,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    // Trigger Meta Pixel AddToCart event
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        value: 26.0,
        currency: 'EUR'
      });
    }
  };
  return <a onClick={e => {
    handleClick();
    return false;
  }} href="https://pay.hotmart.com/W104988940M?checkoutMode=2" className={`hotmart-fb hotmart__button-checkout cta-pulse bg-gradient-to-r from-gold to-gold-bright text-emerald-deep font-bold py-4 px-8 rounded-full text-lg md:text-xl shadow-lg hover:scale-105 transition-transform duration-300 w-full max-w-md mx-auto block text-center no-underline cursor-pointer ${className}`} data-id="element-51">
      {text}
    </a>;
}